import * as React from 'react';
import { Editor } from 'primereact/editor';
import { AdminMedicineModel } from "../../models/medicine";
import Translate from '../../common/functions/translate';

interface IProps {
  handleChange: any,
  medicine: AdminMedicineModel,
  getValue: any,
  selectedLangId: number
}

interface IState {
}

class MedicineTabDriveMachine extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
    };
  }

  public render() {

    const { driveAndMachine } = this.props.medicine;

    return (
      <div className="p-grid p-fluid p-md-12">
        <div className="p-col-12 p-md-12">
          <label>{Translate("DrivingAndUsingMachines")}:</label>
          <Editor
            style={{ width: '100%', height: '150px' }}
            onTextChange={(e) => { this.props.handleChange('driveDescription', e.htmlValue) }}
            value={this.props.getValue('driveDescription')}
          />
        </div>
        {/* <div className="p-col-12 p-md-12">
          <label>{Translate("When using machine")}:</label>
          <Editor
            style={{ width: '100%', height: '150px' }}
            onTextChange={(e) => { this.props.handleChange('machineDescription', e.htmlValue) }}
            value={this.props.getValue('machineDescription')}
          />
        </div> */}
      </div>
    )
  }
}

export default MedicineTabDriveMachine;